import { Container } from 'semantic-ui-react'
import styled from 'styled-components'

export default styled(Container)`
  &&& {
    color: ${props => props.theme.primaryFontColor};

    ${({ theme }) => theme.mediaQueries.mobile} {
      padding: 90px 1rem;
      flex-direction: column;
    }
  }
`
